if (pageDetails.fileName === 'contact.html') {
    window.addEventListener('load', () => {
        const fields = Array.from(document.getElementsByClassName('inputData'));

        const emailOptionLinks = Array.from(document.querySelector('.option:last-of-type').children);
        emailOptionLinks.forEach((link) => {
            link.addEventListener('click', () => {
                window.scroll({
                    top: fields[0].getBoundingClientRect().top + window.pageYOffset - 90,
                    behavior: 'smooth'
                });

                fields[0].focus();
            });
        });

        const formData = {
            name: undefined,
            email: undefined,
            phone: undefined,
            message: undefined
        };

        fields.forEach((field) => {
            let placeholder = field.value;
            let valid;

            field.addEventListener('focusout', () => {
                // Check for validity when the user loses focus from
                // the input field, toggle field class and button disabled
                // attribute when appropriate
                valid = field.validity.valid;
                if (valid && field.value !== '') {
                    field.classList.add('filled');
                    formData[field.name] = field.value;
                } else {
                    field.classList.remove('filled');
                    field.value = placeholder;
                    formData[field.name] = undefined;
                }

                if (Object.values(formData).every(value => value !== undefined)) {
                    submitButton.disabled = false;
                } else {
                    submitButton.disabled = true;
                }
            });

            field.addEventListener('input', () => {
                // Check for validity while the user is typing
                // toggle button disabled attribute when appropriate
                valid = field.validity.valid;
                if (valid && field.value !== '') {
                    formData[field.name] = field.value;
                } else {
                    formData[field.name] = undefined;
                }

                if (Object.values(formData).every(value => value !== undefined)) {
                    submitButton.disabled = false;
                } else {
                    submitButton.disabled = true;
                }
            });

            field.addEventListener('focusin', () => {
                // If user inputted text has not been added to the field
                // then remove the placeholder text.
                if (!field.classList.contains('filled')) {
                    field.value = '';
                }
            });

        });

        const emailPrompt = document.getElementById('email-prompt');
        const submitButton = document.getElementById('submit-button');
        submitButton.addEventListener('click', () => {
            let userData = JSON.stringify(formData);
            console.log(userData);

            let xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    // Replace the paragraph element above the form with the server's response.
                    emailPrompt.innerHTML = this.responseText;

                    if ((window.pageYOffset + 80) > (emailPrompt.getBoundingClientRect().top + window.pageXOffset)) {
                        window.scroll({
                            top: emailPrompt.getBoundingClientRect().top + window.pageYOffset - 80,
                            behavior: 'smooth'
                        });
                    }
                }
            };

            xhr.open("POST", "submission-script.php", true);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.send(userData);

            submitButton.disabled = true;
        });
    });
}